import smoothscroll from "smoothscroll-polyfill"

smoothscroll.polyfill()

document.addEventListener("click", (e) => {
  const link = e.target.closest("[href^='#']")
  if (link) {
    const id = link.getAttribute("href").replace("#", "")
    const dest = document.getElementById(id)
    if (dest) {
      e.preventDefault()
      e.stopPropagation()
      dest.scrollIntoView({ behavior: "smooth" })
    }
  }
})
